import React, { useEffect, useState } from 'react'
import { NextPage } from 'next'
import { handleFetchResponse } from '@lib/handleFetchResponse'
import { useRouter } from 'next/router'
import { default as ErrorComponent } from '@components/Error'
type Props = {}

const NotFound: NextPage<Props> = () => {
  const { asPath, push } = useRouter()
  const path = asPath.split('?')[0]
  const [hasRedirect, setHasRedirect] = useState(true)
  useEffect(() => {
    async function checkRedirect() {
      // We'll check if this asPath is in the redirects map
      // If it is, do a redirect, if not run the normal error program
      const { to }: any = await fetch(
        `${window.location.origin}/api/redirect?path=${path.split('?'[0])}`
      )
        .then(handleFetchResponse)
        .catch(() => {})

      if (!to) {
        setHasRedirect(false)
      } else {
        push(to)
      }
    }
    checkRedirect()
  }, [path]) // eslint-disable-line

  return <ErrorComponent statusCode={404} hideMessage={hasRedirect} />
}

export default NotFound
